export const iconFontAwesomeTravelHotelRoad = (
	<i className="fa-solid fa-road"></i>
);
